<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Editar {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="name"
            :error-messages="formErrors.name"
            label="Nome"
            @input="formErrors.name = ''; createSlug()"
          />
          <v-text-field
            v-model="short_name"
            :error-messages="formErrors.short_name"
            label="Nome"
            @input="formErrors.short_name = ''"
          />
          <v-text-field
            v-model="slug"
            :error-messages="formErrors.slug"
            label="Sigla / Abreviatura"
            @input="formErrors.slug = ''"
          />
          <v-text-field
            v-model="order"
            label="Ordem"
            @input="formErrors.order = ''"
          />
          <v-switch
            v-model="status"
            class="ma-2"
            :label="status ? 'Ativo' : 'Inativo'"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar {{ title }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import handlesServerValidation from '@/mixins/handles-server-validation.js'
import slugify from 'slugify'
export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],
  props: {
    title: { type: String, default: undefined },
    item: { type: Object, default: undefined },
    action: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    name: '',
    short_name: '',
    slug: '',
    order: 0,
    status: true
  }),
  computed: {
  },
  created () {
    if (this.item) {
      this.name = this.item.name
      this.short_name = this.item.short_name
      this.slug = this.item.slug
      this.order = this.item.order
      this.status = this.item.status
    }
  },

  methods: {
    createSlug () {
      this.slug = slugify(this.name).toLowerCase()
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const data = {
        name: this.name,
        short_name: this.short_name,
        slug: slugify(this.slug).toLowerCase(),
        order: this.order,
        status: this.status ? 1 : 0
      }
      try {
        await this.action(this.item.id, data)
        this.$store.dispatch('setSnackBar', { text: `${this.title} atualizado com sucesso!`, color: 'green' })
        this.$emit('resolve', true)
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: `Não foi possível salvar o ${this.title}, tente novamente mais tarde.`, color: 'red' })
      }
    }
  }
}
</script>
